import React from 'react';
import { Card, Typography } from 'antd';
import { ScheduleOutlined } from '@ant-design/icons';
import AppLayout from '../components/AppLayout';
import SchedulerManagement from './admin/SchedulerManagement';
import './AdminPanel.css';

const { Title } = Typography;

const AdminScheduler = () => {
  return (
    <AppLayout activeMenu="/admin/scheduler">
      <Card className="admin-content-card">
        <div className="admin-content-header">
          <Title level={3} style={{ margin: 0 }}>
            <ScheduleOutlined style={{ marginRight: 12, color: '#722ed1' }} />
            Scheduler Management
          </Title>
          <p style={{ margin: '8px 0 0 0', color: '#666' }}>
            Configure automated scraping schedules
          </p>
        </div>
        <SchedulerManagement embedded />
      </Card>
    </AppLayout>
  );
};

export default AdminScheduler;
